"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.healthCheck = void 0;
/**
 * Dummy method, used to prove the index.js is exporting correctly
 * @returns true
 */
function healthCheck() {
    return true;
}
exports.healthCheck = healthCheck;
//# sourceMappingURL=health-check.js.map